/**
 * Returns the list of 'CustomInstruction' InputField parameters for the selected tests on the Gear requisition.
 */
const getCustomInstructionFields = (orderableItem, gearRequisition) => {
	if (!gearRequisition || !orderableItem?.inputFields?.length) {
		return [];
	}

	/**
	 * Convert the selected Gear Req fields (panel, components, add-ons) into an array of
	 * OmsInputField Ids
	 */
	const selectedInputFieldIds = [
		gearRequisition.panel,
		...(gearRequisition.components || []),
		...(gearRequisition.addons || [])
	]
		.map(Number)
		.filter(Boolean);

	/**
	 * Loop through all InputFields on in the OmsOrderableItem and return all 'CustomInstruction'
	 * parameters for the selected Ids.
	 */
	const customInstructions =
		orderableItem.inputFields
			.filter((field) => selectedInputFieldIds.includes(field.id) && field.inputFieldParams?.length)
			.flatMap((field) => field.inputFieldParams)
			.filter((param) => param.name === 'CustomInstruction' && param.value)
			.sort((a, b) => a.id - b.id) || [];

	return customInstructions;
};

/**
 * Get custom instructions of a particular type.
 * A 'CustomInstruction' type is stored at the beginning of the parameter value in the format `{type}|`.
 * Passing in an empty instructionType will return all custom instructions
 */
export const getCustomInstructionFieldsByType = (orderableItem, gearRequisition, instructionType) => {
	const typeKey = instructionType ? instructionType.toLowerCase() : '';
	return getCustomInstructionFields(orderableItem, gearRequisition)
		.filter((instruction) => instruction.value?.toLowerCase().startsWith(typeKey))
		.map((instruction) => ({
			...instruction,
			// Remove the type key from the value
			value: instruction.value.substring(typeKey.length)
		}));
};